import Dropdown from 'flarum/common/components/Dropdown';
import DiffList from './DiffList';
import Icon from 'flarum/common/components/Icon';
import DiffListState from '../states/DiffListState';

/**
 * The `DiffDropdown` component is the entrance point for this extension.
 * It's the component that you see when you click on "Edited" button.
 * It also contains DiffList components.
 */
export default class DiffDropdown extends Dropdown {
  static initAttrs(attrs) {
    attrs.className = 'DiffDropdown';
    attrs.buttonClassName = 'Button Button--link';
    attrs.menuClassName = attrs.menuClassName;
    attrs.label = app.translator.trans('huseyinfiliz-diff.forum.editedText');
    attrs.icon = 'fas fa-history';
    super.initAttrs(attrs);
  }
  oninit(vnode) {
    super.oninit(vnode);

    /**
     * The post that we're working with.
     *
     * @type {Post[]}
     */
    this.post = this.attrs.post;

    /**
     * Create a new revision list.
     *
     * @type {DiffListState}
     */
    this.listState = new DiffListState(this.post, false, null);
  }
  getButton() {
    const vdom = super.getButton();
    vdom.attrs.title = this.attrs.label;
    vdom.attrs.onclick = this.onclick.bind(this);
    return vdom;
  }
  getButtonContent() {
    return [m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }), m("span", {
      className: "Button-label"
    }, this.attrs.label)];
  }
  getMenu() {
    const revisionCount = this.attrs.post.revisionCount();
    return m("div", {
      className: 'Dropdown-menu ' + this.attrs.menuClassName
    }, m("div", {
      className: "DiffList-header"
    }, m("h4", null, app.translator.trans('huseyinfiliz-diff.forum.revisionInfo', {
      revisionCount
    }))), this.showing ? m(DiffList, {
      state: this.listState
    }) : '');
  }

  /**
   * Load revision list.
   */
  onclick() {
    this.listState.load();
  }
}
flarum.reg.add('huseyinfiliz-diff', 'forum/components/DiffDropdown', DiffDropdown);